'use client';

import PostPageClient from '@/components/detail/ClientPostEntry';
import MobilePostPage from '@/components/detail/MobilePostDetail';
import PostSkeleton from '@/components/detail/PostSkeleton';
import { useResponsive } from '@/hooks';
import { detectDevice } from '@/lib/utils';
import { useEffect, useState } from 'react';

interface PostPageResponsiveProps {
    post: any;
    initialIsMobile?: boolean;
    detail?: boolean;
    qualityComments?: any[];
}

const PostPageResponsive = ({ post, initialIsMobile = false, detail = false, qualityComments = [] }: PostPageResponsiveProps) => {
    const { width, isClient } = useResponsive({
        initialIsMobile,
    });
    const [isMobile, setIsMobile] = useState(initialIsMobile);
    useEffect(() => {
        if (isClient) {
            const res = detectDevice(navigator.userAgent);
            setIsMobile(!res.isDesktop);
        }
    }, [isClient, width]);
    // 服务端渲染时，使用初始的设备类型
    if (!isClient) {
        if (initialIsMobile) {
            return <MobilePostPage post={post} qualityComments={qualityComments} />;
        } else {
            return (
                <>
                    <PostPageClient post={post} detail={detail} qualityComments={qualityComments} />
                    <main className="min-h-screen">
                        <div className="max-w-2xl mx-auto px-1 py-4 sm:px-6 md:px-8">
                            <div className="space-y-6">
                                {[...Array(5)].map((_, index) => (
                                    <PostSkeleton key={index} />
                                ))}
                            </div>
                        </div>
                    </main>
                </>
            );
        }
    }

    // 客户端渲染时，根据当前屏幕尺寸决定显示哪个组件
    if ((width && width < 900) || isMobile) {
        return <MobilePostPage post={post} qualityComments={qualityComments} />;
    } else {
        return (
            <>
                <PostPageClient post={post} detail={detail} qualityComments={qualityComments} />
                <main className="min-h-screen">
                    <div className="max-w-2xl mx-auto px-1 py-4 sm:px-6 md:px-8">
                        <div className="space-y-6">
                            {[...Array(5)].map((_, index) => (
                                <PostSkeleton key={index} />
                            ))}
                        </div>
                    </div>
                </main>
            </>
        );
    }
};

export default PostPageResponsive; 